/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-events',
    'pip-model',
    'window'
],
function(
    pipEvents,
    pip,
    window
){

	function initEventListeners(){
		pipEvents.fbr.fbrLinkClicked.off('.fbrLinkClicked');
		pipEvents.fbr.fbrLinkClicked.on('.fbrLinkClicked', function(evtType, data) {
			if (!data) {
				return;
			}
			var recommendationVersion = data.recommendationVersion || "model4";
			var featureVersion = data.featureVersion  || "model1";
		   if (window.digitalData && window.digitalData.event) {
			window.digitalData.event.push({
	                category: {
	                    primaryCategory: "stash"
	                },
	                eventInfo: {
	                    eventName: "recommendation pip load"
	                },
	                eventMode: "stash",
	                stash: {
	                    recommendation: {
	                        recommendationType: "fbr",
	                        pageType: "pip",
	                        displayPosition: data.displayPosition,
	                        anchorProductSku: data.anchorProductSku,
	                        strategy: "n/a",
	                        recommendationVersion: recommendationVersion,
	                        featureVersion: featureVersion,
	                        interval: "n/a",
	                    }
	                }
	            });
				if(pip.debugMode){
					window.location = data.href + window.location.search;
				} else {
					window.location = data.href;
				}
		    }
		});

	}


	return {
		init: function(){
			initEventListeners();
		},

	}

});

}.call(window));